export interface Fleet {
  id: string
  vehicles: Vehicle[]
  name: string
  selected: boolean
  deleteFlag: boolean
}
export interface Vehicle {
  id: string
  name: string
  selected: boolean
  deleteFlag: boolean,
  displayName: string
}
export interface Extension {
  name: string
  selected: boolean
}

export interface Map {
  [key: string]: boolean
}

type IpaDatasetFilterInt64 = {
  type: 'Fleet' | 'Vehicle'
  value: number[]
}

type IpaDatasetFilterString = {
  type: 'Collection' | 'Extension'
  value: string[]
}

type IpaDatasetFilterDateTime = {
  type: 'StartDate' | 'EndDate'
  value: Date
}

export type IpaDatasetFilter =
  | IpaDatasetFilterInt64
  | IpaDatasetFilterString
  | IpaDatasetFilterDateTime
export interface DataSet {
  id: number
  name: string
  type: string
  filters: IpaDatasetFilter[]
}

export interface DataSetBody {
  name: string
  description: string
  type: string
  filters: IpaDatasetFilter[]
  upload_file_version_id: number[]
}

export type DataSetUpdateBody = Partial<DataSetBody> & {
  filters?: never
  frequency?: number
}
export interface DataSetUpdate extends DataSetBody {
  name: string
  type: string
  filters: IpaDatasetFilter[]
}
export interface Version {
  id: number
  extension: string
  size: number
  selected: boolean
}

export interface DateRangeObj {
  startDate: string | null
  endDate: string | null
}

// STORAGE

export const maxOptions = [50, 200, 500, 2000]
export const dynamicDataExtensions = [
  { name: 'asc', selected: false },
  { name: 'blf', selected: false },
  { name: 'csv', selected: false },
  { name: 'dat', selected: false },
  { name: 'db', selected: false },
  { name: 'img', selected: false },
  { name: 'LOG CSV', selected: false },
  { name: 'mat', selected: false },
  { name: 'mf4', selected: false },
  { name: 'vsb', selected: false },
  { name: 'xml', selected: false },
]

export const dropdownButtonOptions = [
  { id: 1, name: 'View', icon: 'info', action: 'view' },
  { id: 2, name: 'Delete', icon: 'trash', action: 'delete' },
]
